import { createClient, type SupabaseClient } from "@supabase/supabase-js";
import { SUPABASE_ANON_KEY, SUPABASE_URL, HAS_SUPABASE_CONFIG } from "./env";

// Normaler Browser-Client: ausschließlich anon key + authentifizierte
// User-Session. RLS ist die serverseitige Grenze. NIEMALS service_role
// oder andere Secrets im Frontend.
let client: SupabaseClient | null = null;

export function getSupabase(): SupabaseClient {
  if (!HAS_SUPABASE_CONFIG) {
    throw new Error("SUPABASE_NOT_CONFIGURED");
  }
  if (!client) {
    client = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
      auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: false },
      realtime: { params: { eventsPerSecond: 5 } },
    });
  }
  return client;
}
